<modal #modalRef [backdrop]="true" [closeOnOutsideClick]="true" class="modal-voucher-details">
  <modal-content>
    <div class="voucher-details">
      <img class="voucher-logo" [src]="voucher?.vouchers_provider?.logo_url" alt="Voucher">

      <div class="voucher-title">R$ {{voucher?.amount}} para usar no {{voucher?.vouchers_provider?.name}}</div>
      <div class="voucher-description">
        Copie o código e siga as instruções abaixo para realizar o resgate do seu voucher:
      </div>

      <div class="coupon-content">
        <span>{{voucher?.code}}</span>

        <button
          [class.active]="copied"
          [copy-clipboard]="voucher?.code"
          (copied)="onCopy()"
        >
          {{ copied ? 'copiado' : 'copiar' }}
        </button>
      </div>

      <div class="voucher-instructions">
        <div class="instructions-title">Veja como utilizar</div>

        <div [innerHTML]="voucher?.vouchers_provider?.rules" class="rules"></div>
      </div>

    </div>
  </modal-content>
</modal>
